import { render, staticRenderFns } from "./ReadonlyField.vue?vue&type=template&id=ccaae2a0&scoped=true&"
import script from "./ReadonlyField.vue?vue&type=script&lang=js&"
export * from "./ReadonlyField.vue?vue&type=script&lang=js&"
import style0 from "./ReadonlyField.vue?vue&type=style&index=0&id=ccaae2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaae2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccaae2a0')) {
      api.createRecord('ccaae2a0', component.options)
    } else {
      api.reload('ccaae2a0', component.options)
    }
    module.hot.accept("./ReadonlyField.vue?vue&type=template&id=ccaae2a0&scoped=true&", function () {
      api.rerender('ccaae2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ReadonlyField.vue"
export default component.exports